import { useEffect } from "react";
import { useForm } from "../useForm";

import InputTextOnly from "../../controls/InputTextOnly";

const initialFValues = {
  name: "",
  address_1: "",
  address_2: "",
  city: "",
  zip: "",
  state: "",
  country: "",
  phone_number: "",
};

export default function TenantDetailsForm(props) {
  const { actionCall, isEdit, tenant } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    temp.name = null;
    if (!fieldValues.name) {
      temp.name = "Please fill out field.";
    }

    temp.address_1 = null;
    if (!fieldValues.address_1) {
      temp.address_1 = "Please fill out field.";
    }

    for (const field of ["city", "zip", "state", "country"]) {
      temp[field] = fieldValues[field] ? null : "Please fill out field.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange } =
    useForm(initialFValues, false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (tenant?.id) {
      setValues((prev) => ({ ...prev, ...tenant }));
    }
  }, [tenant, setValues]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="p-4">
        <div className="space-y-3">
          <div>
            <div className="grid grid-cols-2 gap-4 max-w-4xl">
              <div>
                <InputTextOnly
                  label="Name"
                  name="name"
                  onChange={handleInputChange}
                  value={values.name}
                  labelOn={true}
                  error={errors.name}
                />
              </div>
              <div>
                <InputTextOnly
                  label="Phone Number"
                  name="phone_number"
                  onChange={handleInputChange}
                  value={values.phone_number}
                  labelOn={true}
                  error={errors.phone_number}
                />
              </div>
              <div>
                <InputTextOnly
                  label="Address 1"
                  name="address_1"
                  onChange={handleInputChange}
                  value={values.address_1}
                  labelOn={true}
                  error={errors.address_1}
                />
              </div>
              <div>
                <InputTextOnly
                  label="Address 2"
                  name="address_2"
                  onChange={handleInputChange}
                  value={values.address_2}
                  labelOn={true}
                  error={errors.address_2}
                />
              </div>
              <div>
                <InputTextOnly
                  label="City"
                  name="city"
                  onChange={handleInputChange}
                  value={values.city}
                  labelOn={true}
                  error={errors.city}
                />
              </div>
              <div>
                <InputTextOnly
                  label="Zip Code"
                  name="zip"
                  onChange={handleInputChange}
                  value={values.zip}
                  labelOn={true}
                  error={errors.zip}
                />
              </div>
              <div>
                <InputTextOnly
                  label="Country"
                  name="country"
                  onChange={handleInputChange}
                  value={values.country}
                  labelOn={true}
                  error={errors.country}
                />
              </div>
              <div>
                <InputTextOnly
                  label="State"
                  name="state"
                  onChange={handleInputChange}
                  value={values.state}
                  labelOn={true}
                  error={errors.state}
                />
              </div>
            </div>
            {!isEdit && (
              <div className="mt-4 max-w-4xl rounded-md border border-indigo-100 bg-indigo-50 px-4 py-3 text-sm text-indigo-800">
                Creating this tenant will also create a protected product category named
                {" "}
                <span className="font-semibold">Default Category</span>. Products imported
                without a QuickBooks category will be assigned to it automatically.
              </div>
            )}
          </div>
        </div>

        <div className="sm:flex-no-wrap">
          <div className="my-auto flex items-center justify-between w-full">
            <div>
              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center mt-3"
              >
                {isEdit ? "Save" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
